const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import { BaseObject, MongoObject } from './_baseClasses'
import { AuctionListing, sortOrderTypes } from './AuctionListing';
import { Auction, auctionStatus } from './Auction';
import * as utils from "./utils"

import * as telegram from "./telegram"
import { } from './Portfolio';

export class AuctionListings extends BaseObject {
  public setID: number = null
  public playID: number = null
  public playerID: number = null

  public open: boolean = null
  public sort: sortOrderTypes = null
  public moments: AuctionListing[] = null
  public total: number = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object, open?: boolean, setID?: number, playID?: number, playerID?: number, sort?: sortOrderTypes) {
    super()
    if (po) this.injectPlainObject(po)
    this.open = open
    this.setID = setID
    this.playID = playID
    this.playerID = playerID
    this.sort = sort
    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
  }

  public isSafe(): boolean {
    return true
  }



}

(async () => {
})();
